import { render, staticRenderFns } from "./Revista.vue?vue&type=template&id=1b46e96a"
import script from "./Revista.vue?vue&type=script&lang=js"
export * from "./Revista.vue?vue&type=script&lang=js"
import style0 from "./Revista.vue?vue&type=style&index=0&id=1b46e96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports